export function base64urlEncode(data: any) {
  const dataStr = JSON.stringify(data);
  return btoa(dataStr)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}
